import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';

export const initialPageViewGuid = uuidv4();

const usePageViewGuid = () => {
  const router = useRouter();

  const [pageViewGuid, setPageViewGuid] = useState(initialPageViewGuid);
  const [initAsPath] = useState(router.asPath);

  useEffect(() => {
    if (router.asPath === initAsPath && pageViewGuid === initialPageViewGuid)
      return;

    setPageViewGuid(uuidv4());
  }, [router.asPath]);

  return typeof window === 'undefined' ? null : pageViewGuid;
};

export default usePageViewGuid;
